import { Box, Heading, Image, Paragraph, ResponsiveContext, Text } from 'grommet';
import { useContext } from 'react';

import Amy from 'assets/meetTheTeam/Amy.png';
import BrianHeather from 'assets/meetTheTeam/Brian-Heather.png';
import Danielle from 'assets/meetTheTeam/Danielle.png';
import FMHVolunteers from 'assets/meetTheTeam/FMH-volunteers.png';
import Jess from 'assets/meetTheTeam/Jess.png';
import Jocelyn from 'assets/meetTheTeam/Jocelyn.png';
import Lori from 'assets/meetTheTeam/Lori.png';
import Sheila from 'assets/meetTheTeam/Sheila.png';
import Tracy from 'assets/meetTheTeam/Tracy.png';
import { BannerImage } from 'components/shared/BannerImage';

export const MeetTheTeam = () => {
    const size = useContext(ResponsiveContext);
    const isMobile = size === 'small';
    return (
        <>
            <BannerImage />
            <Box alignSelf="center" width="xlarge" pad="large">
                <Heading level={1}>MEET THE TEAM</Heading>
                <Box align="center">
                    <Box margin={{ bottom: 'small' }} width={{ min: '100px', max: '545px' }}>
                        <Image
                            src={BrianHeather}
                            alt="Brian and Heather McKita"
                            height="100%"
                            width="100%"
                            loading="lazy"
                        />
                    </Box>
                    <Text weight="bold" size="large">
                        Heather & Brian McKita
                    </Text>
                    <Text size="large" color="pink">
                        Chelsea&apos;s Parents
                    </Text>
                </Box>
                <Paragraph fill>
                    We started this foundation to provide a way to support other children and young
                    adults going through similar situations and/or having similar needs as Chelsea.
                    She was always looking out for the next kid and it is now our honor and
                    privilege to do this in her memory.
                </Paragraph>
                <Heading level={2}>Core Volunteers</Heading>
                <Paragraph fill>
                    We are so thankful for every single person who has volunteered at one of our
                    events! A lot needs to happen beyond the day of in advance of these events.
                    Below you&apos;ll find pictures of our core group of volunteers and a quick note
                    as to why they do this. They all generously devote their time planning and
                    running our events. For this and so many other reasons, we are eternally
                    grateful!!! 💙
                </Paragraph>
                <Box gap="large">
                    <Box direction={isMobile ? 'column' : 'row'} gap="large">
                        <Box>
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Amy}
                                    alt="Amy Burkhart"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Amy Burkhart
                            </Text>
                            <Text size="large" color="pink">
                                Family Friend
                            </Text>
                            <Paragraph>
                                I am excited and honored to be part of the foundation. I had the
                                privilege of being in Chelsea&apos;s life from the beginning and
                                watching her grow into an amazing young lady. We lost her way too
                                soon and this foundation has been a great way to honor her and to
                                represent the true essence of who Chelsea was; a person who was
                                always more concerned for others than herself.
                            </Paragraph>
                        </Box>
                        <Box>
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Danielle}
                                    alt="Danielle Knochel"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Danielle Knochel
                            </Text>
                            <Text size="large" color="pink">
                                Family Friend
                            </Text>
                            <Paragraph>
                                Being asked to be part of this foundation has been one of my biggest
                                honors. It represents everything Chelsea stood for, and I love
                                helping to continue her legacy.
                            </Paragraph>
                        </Box>
                        <Box>
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Jess}
                                    alt="Jess Jacobs"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Jess Jacobs
                            </Text>
                            <Text size="large" color="pink">
                                Family Friend
                            </Text>
                            <Paragraph>
                                I volunteer because I have seen the difference we can make in
                                helping others who are experiencing similar situations to those
                                Chelsea dealt with. She was such an amazing person and I believe she
                                is happy to see us serving others in memory of her.
                            </Paragraph>
                        </Box>
                    </Box>
                    <Box direction={isMobile ? 'column' : 'row'} gap="large">
                        <Box>
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Jocelyn}
                                    alt="Jocelyn Parris"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Jocelyn Parris
                            </Text>
                            <Text size="large" color="pink">
                                Family Friend
                            </Text>
                            <Paragraph>
                                I choose to volunteer for the foundation because the McKita family
                                is near and dear to my heart and it&apos;s absolutely amazing what
                                they do and what this foundation does! The strength, positivity, and
                                pure light the McKitas have is shown and passed to me, and the
                                children and families we support.
                            </Paragraph>
                        </Box>
                        <Box>
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Lori}
                                    alt="Lori Keller"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Lori Keller
                            </Text>
                            <Text size="large" color="pink">
                                Family Friend
                            </Text>
                            <Paragraph>
                                I volunteer to help ensure that the donations continue to be placed
                                in the hands of the kids and families that need it most. Without
                                this foundation and others like it, research and tools wouldn&apos;t
                                be available to them. Also, it feels really good to play a role in
                                granting “bucket list” wishes!!
                            </Paragraph>
                        </Box>
                        <Box>
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Sheila}
                                    alt="Sheila Deily"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Sheila Deily
                            </Text>
                            <Text size="large" color="pink">
                                Chelsea&apos;s Aunt/Family friend
                            </Text>
                            <Paragraph>
                                I choose to volunteer because it is a great way to honor my niece,
                                and to serve the community and help others in her memory.
                            </Paragraph>
                        </Box>
                    </Box>
                    <Box direction={isMobile ? 'column' : 'row'} gap="large">
                        <Box
                            basis={isMobile ? undefined : '1/3'}
                            pad={{ right: isMobile ? undefined : 'medium' }}
                        >
                            <Box
                                margin={{ bottom: 'small' }}
                                width={{ min: '100px', max: '545px' }}
                            >
                                <Image
                                    src={Tracy}
                                    alt="Tracy Fullerton"
                                    height="100%"
                                    width="100%"
                                    loading="lazy"
                                />
                            </Box>
                            <Text weight="bold" size="large">
                                Tracy Fullerton
                            </Text>
                            <Text size="large" color="pink">
                                Family Friend
                            </Text>
                            <Paragraph>
                                Chelsea and I shared a passion for design. Her dedication to design
                                was not only about aesthetics, but also about using creativity to
                                make an impact on the world around us. Being a part of the
                                foundation allows me to honor her values and help guide us towards
                                fulfilling our mission. I am deeply committed to ensuring that the
                                foundation thrives in ways that reflect Chelsea&apos;s passions and
                                goals.
                            </Paragraph>
                        </Box>
                    </Box>
                </Box>
                <Heading level={2}>Website Volunteers</Heading>
                <Paragraph fill>
                    Pictured below is the group of volunteers that creates and manages our website
                    and social media. We&apos;d be lost without them! 💙
                </Paragraph>
                <Box align="center">
                    <Box margin={{ bottom: 'small' }} width={{ min: '100px', max: '545px' }}>
                        <Image
                            src={FMHVolunteers}
                            alt="FMH Volunteers"
                            height="100%"
                            width="100%"
                            loading="lazy"
                        />
                    </Box>
                    <Text size="large" color="pink">
                        Danial Nasirullah, Tom Bertrand, Jamie Slater, Abby Tasser, Elliot Radsliff,
                        Ben Martin
                    </Text>
                </Box>
            </Box>
        </>
    );
};
